window.process = {
  env: {
    NODE_ENV: 'development',
  },
  cwd: () => '/',
};
